import { getNotifRoute } from './notificationRoutes';

// Where a tapped push leads (v1.0.2 §6c). The push data is the notification's metadata (as
// strings) plus notificationType and notificationId. A trade signal has no page: its id goes to
// AppNav, which opens the confirm dialog from the server's own copy, never from the push.
export function pushTapTarget(data) {
  const type = data?.notificationType;
  const notificationId = data?.notificationId || null;
  if (type === 'trade_signal') {
    return { path: notificationId ? `/?notification=${encodeURIComponent(notificationId)}` : '/', notificationId };
  }
  return { path: type ? getNotifRoute({ type, metadata: data }) : null, notificationId };
}
